module.exports = __webpack_public_path__ + "54c9b3ad4ffe1ccef296b73a5dca7bb5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-32.png
// module id = 2713
// module chunks = 0